module.exports = __webpack_public_path__ + "static/media/paginationItems.c37892c4.svg";